export const NAMESPACE = "AddContactMemberModal";

export const STYLE_LABELS = {
  color: "#343434",
  fontSize: "16px",
  fontWeight: 600
};

export const FORM_ID = "AddContactMemberForm";
